import apiClient from "../client/apiClient";
import { ENDPOINTS } from "../config/endpoints";
import { normalizeApiError } from "../utils/handleError";
import { unwrapApiResponse } from "../utils/unWrapApiResponse.js";

/**
 * Generate income verification URL
 * @param {{
 *   stage: string,
 *   type: string,
 *   return_url: string
 * }} payload
 */

export const generateIncomeVerificationUrl = async (payload) => {
  try {
    const response = await apiClient.post(ENDPOINTS.INCOME_VERIFICATION, payload);
    return unwrapApiResponse(response, {
      extract: "responseData",
      fallbackMessage: "Failed to generate income verification request",
    });
  } catch (error) {
    throw normalizeApiError(error);
  }
};
